import * as olProj from 'ol/proj';
import * as availableLegends from '../../lib/assets/JSON/legends/legends.json';
import * as olExtent from 'ol/extent';
import { Legend } from './legend';
import { MapService } from '../services/map.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Subject, throwError } from 'rxjs';

export abstract class Layer {

    id: string;
    label: string;
    url: string;
    type: string;
    opacity: number;
    visible: boolean;
    legend: any;
    hasLegend?: boolean;
    swipeState?: 'left'|'right'|'both'|'none'
    //children?: Layer[];
    // to add dynamic properties
    //[key: string]: any;

    constructor(id: string, label: string, type: string) {
        this.id = id;
        this.label = label;
        this.type = type;
        this.opacity = 1;
        this.visible = true;
    }

    abstract toOlLayer();

    setLegend() {
        let jsonLegends: any = (availableLegends as any).default;
        jsonLegends.forEach(element => {
            if (element.label === this.label) {
                this.legend = element
                return;
            }
        });
    }

    protected getResolutionForScale(scale) {
        //standard 90,71 dpi
        //const dpi = 25.4 / 0.28;
        // * test -> EPSG must be dynamic later
        const mpu = olProj.get('EPSG:3857').getMetersPerUnit();
        const inchesPerMeter = 39.3701;
        //return parseFloat(scale) / (mpu * inchesPerMeter * dpi);
        return parseFloat(scale) / (mpu * inchesPerMeter * 96);
    }

    //not tested yet
    protected getZoomlevelForScale(scale, viewResolutions) {
        var mpu = 1;
        var inchesPerMeter = 39.3701;
        // var viewResolutions = [];
        // var projection = olProj.get('EPSG:3812');//EPSG:3857
        // var projectionExtent = projection.getExtent();//[-20037508.342789244,-20037508.342789244,20037508.342789244,20037508.342789244]
        // var size = olExtent.getWidth(projectionExtent) / 256; //156543.03392804097
        // for (var z = 0; z < 27; ++z) {
        //     viewResolutions[z] = size / Math.pow(2, z);
        // }
        var resolution = this.getResolutionForScale(scale);
        // console.log(viewResolutions)

        for (var i = 0; i < viewResolutions.length; i++) {
            if (viewResolutions[i] < resolution) {
                //console.log("returning " + i);
                return (i === 0) ? 0 : i - 1;
                break;
            }
        }
        return viewResolutions.length;
    }

}
